<template>
  <div class="col-xl-3 col-lg-12 theiaStickySidebar">
    <!-- Settings Sidebar -->
    <div class="card">
      <div class="card-body">
        <div class="settings-sidebar">
          <h4 class="fw-semibold mb-3">Organization Update</h4>
          <div class="list-group list-group-flush settings-sidebar">
            <router-link 
              :to="`/leads-organization/${id}/initial-info`" 
              class="fw-medium"
            >Initial Info</router-link>
            <router-link 
              :to="`/leads-organization/${id}/concern-person-info`" 
              class="fw-medium"
            >Concern Person Info</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- /Settings Sidebar -->
  </div>
</template>

<script>
export default {
  computed: {
    id() {
      return this.$route.params.id; // Access the `id` from the URL
    }
  }
};
</script>
